var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tlive-create__cover", on: { click: _vm.setCover } },
    [
      _c("yxt-image", { attrs: { src: _vm.value, fit: "cover" } }),
      _c("div", { staticClass: "tlive-create__cover--text" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("pc_biz_setCover" /* 设置封面 */)) + "\n  "
        ),
      ]),
      _c("yxtbiz-image-cropper", {
        attrs: {
          "module-name": "tlive",
          "function-name": "tlive",
          "app-code": "tlive",
          size: 10240,
          rate: "16:9",
          suggest: { w: 640, h: 360 },
          src: _vm.value,
          visible: _vm.showCropper,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showCropper = $event
          },
          complete: _vm.complete,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }